import { FC } from 'react';
import loadable from '@loadable/component';
import { NotifierLazyLoad } from '@edikk-edikk/notifier';

const Notifier = loadable(() => import('@edikk-edikk/notifier'), {
  resolveComponent: ({ Notifier: Component }) => Component,
});

const NotifierWrapper: FC = () => <NotifierLazyLoad Notifier={Notifier} top={8} />;

export { NotifierWrapper };
